/**
 * Web twin of apps/mobile/components/ActionCard.js.
 * Light grey card + outline CTA — tertiary actions in the scroll body
 * (reject / convert), never competing with the FloatingFooter primary.
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props {
  title: string;
  description: string;
  ctaLabel: string;
  onClick: () => void;
  variant?: 'outline' | 'outline-danger';
  disabled?: boolean;
  className?: string;
  ctaProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  children?: ReactNode;
}

export default function ActionCard({
  title,
  description,
  ctaLabel,
  onClick,
  variant = 'outline',
  disabled = false,
  className = '',
  ctaProps,
}: Props) {
  const danger = variant === 'outline-danger';
  return (
    <div className={`rounded-[10px] bg-[#f5f5f5] p-4 ${className}`}>
      <p className="text-sm font-bold text-x9-ink">{title}</p>
      <p className="mt-1 text-sm leading-relaxed text-x9-marineSoft">{description}</p>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={`mt-3 flex w-full items-center justify-center rounded-[10px] border px-4 py-3 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-45 ${
          danger
            ? 'border-x9-error text-x9-error hover:bg-x9-error/5'
            : 'border-x9-marine/25 text-x9-marineSoft hover:border-x9-marine/40 hover:bg-white hover:text-x9-marine'
        }`}
        {...ctaProps}
      >
        {ctaLabel}
      </button>
    </div>
  );
}
